<template>
  <div>
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-lg font-semibold text-gray-800">Patient Visit Summary</h2>
    </div>
    <div v-if="loading" class="py-10 text-center text-sm text-gray-400">Loading…</div>
    <DataTable
      v-else
      :columns="columns"
      :rows="rowData"
      row-key="mbi"
      max-height="700px"
      saved-view-key="ext-patient-visits"
      :has-saved="hasSavedView"
      :saved-just-saved="savedViewJustSaved"
      v-model:sort-model="sortModel"
      export-title="Patient Visit Summary"
      export-filename="cclf_patient_visits"
      empty-text="No visit data."
      @save-view="saveView"
      @reset-view="resetView"
    />
  </div>
</template>

<script>
import { sensitiveCell } from '@/utils/demoSpoof'
import { DataTable } from '@/components/External/table'
import savedView from '@/mixins/savedView'

export default {
  name: 'CCLFReport_PatientVisits',
  components: { DataTable },
  mixins: [savedView],
  savedView: { key: 'ext-patient-visits', fields: ['sortModel'], scopeProp: 'entityId' },
  props: {
    contractId: { type: String, default: null },
    performanceYear: { type: Number, default: null },
    dosthru: { type: String, default: null },
    entityId: { type: Number, default: null },
    careSetting: { type: String, default: '' },
  },
  data() {
    return {
      rowData: [],
      loading: false,
      sortModel: { key: null, dir: 'asc' },
      columns: [
        { field: 'mbi', header: 'MBI', type: 'text', sticky: true, width: 130, filterable: true, cellClass: () => sensitiveCell('identifier') },
        { field: 'last_name', header: 'Last Name', type: 'text', width: 130, filterable: true, cellClass: () => sensitiveCell('person-last') },
        { field: 'first_name', header: 'First Name', type: 'text', width: 120, filterable: true, cellClass: () => sensitiveCell('person-first') },
        { field: 'facility', header: 'Facility', type: 'text', width: 200, filterable: true, cellClass: () => 'sensitive' },
        { field: 'patient_status', header: 'Status', type: 'text', width: 100, filterable: true },
        { field: 'total_visits', header: 'Total Visits', type: 'number', width: 110 },
        { field: 'last_visit_date', header: 'Last Visit', type: 'date', width: 110 },
        { field: 'awv_billed', header: 'AWV Billed', type: 'text', width: 100 },
        { field: 'tcm_billed', header: 'TCM Billed', type: 'text', width: 100 },
        { field: 'ccm_billed', header: 'CCM Billed', type: 'text', width: 100 },
      ],
    }
  },
  watch: {
    careSetting() { this.loadData() },
    contractId() { this.loadData() },
    performanceYear() { this.loadData() },
    dosthru() { this.loadData() },
    entityId() { this.loadData() },
  },
  mounted() {
    if (this.contractId && this.performanceYear) this.loadData()
  },
  methods: {
    async loadData() {
      if (!this.contractId || !this.performanceYear) return
      this.loading = true
      try {
        const response = await this.$axios.post('/api/portfolio_management/cclf-report/patient-visits/', {
          contract_id: this.contractId, performance_year: this.performanceYear,
          dosthru: this.dosthru, entity_id: this.entityId,
          care_setting: this.careSetting || undefined,
        })
        this.rowData = response.data
      } catch (error) {
        console.error('Failed to load patient visits:', error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
